module.exports = __webpack_public_path__ + "static/img/title_bg_right.cbaf477.png";


//////////////////
// WEBPACK FOOTER
// ./static/components/loadListTail/title_bg_right.png
// module id = 158
// module chunks = 17 18